<script setup lang="ts">
import { defineComponent } from "vue";
import type { RouteLocationRaw } from "vue-router";

defineComponent({
  name: "NewsMenuItem",
});

interface Props {
  title: string;
  isActive: boolean;
  link: RouteLocationRaw;
}

defineProps<Props>();

</script>

<template>
  <div :class="['news-menu-item', { active: isActive }]">
    <router-link class="news-menu-link" :to="link">{{ title }}</router-link>
  </div>
</template>
<style scoped>
.news-menu-item {
  margin: 0 12px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 25px;
  transition: background-color 0.3s;
}

.news-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.news-menu-item.active {
  background-color: rgba(255, 255, 255, 0.2);
}

.news-menu-link {
  color: white;
  text-decoration: none;
  font-size: var(--font-size-header);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.news-menu-link:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .news-menu-item {
    margin: 0 6px;
    padding: 6px 12px;
  }

  .news-menu-link {
    font-size: var(--font-size-header);
  }
}

@media (max-width: 520px) {
  .news-menu-link {
    font-size: var(--font-size-menu);
  }
}

@media (max-width: 480px) {
  .news-menu-item {
    margin: 0 4px;
    padding: 5px 10px;
  }

  .news-menu-link {
    font-size: var(--font-size-menu);
  }
}
</style>
